
CheckoutV2.Login = function(checkout) {
    var checkoutLogin = this;

    this.saved = true;
    this.lookup = false;
    this.guest = false;

    this.init = function() {
        checkoutLogin.login = new Login('#loginModal');
        // if we are soft logged in, pre-fill the email address on the login form
        if (checkout.session
            && checkout.session.get('softLoggedIn')
            && checkout.session.get('billing')
            && checkout.session.get('billing').email
            && checkoutLogin.login.$email
            ) {
            checkoutLogin.login.$email.val( checkout.session.get('billing').email );
            checkoutLogin.login.$password.val('');
        }

        checkoutLogin.login.callbacks = {
            'submit' : {
                'done' : function(response) {
                    //console.log( response );
                    checkout.config.showSaveAddress = response.data.showSaveAddress;
                    checkout.session.load(response.data);
                    // on login, reset listrak cart, so cart reaches listrak for logged in
                    // user
                    if (checkout.cart && checkout.cart.listrakItemsString)
                        checkout.cart.listrakItemsString = "";
                    if (checkout.config.promoCodeEnabled) {
                        checkout.cart.promos.validateCartLogin({
                          refreshCart: response.data.refreshCart,
                        });
                    } else {
                        if (response.data.refreshCart) {
                            checkout.cart.checkItems(true, true);
                        } else {
                            checkout.cart.checkItems();
                        }
                        checkoutLogin.setEstimatedShippingFields();
                        checkoutLogin.loadAddresses();
                        checkoutLogin.proceed();
                    }
                }
            }
        };

        checkoutLogin.lookup = new CheckoutV2.Login.Lookup(checkout, checkoutLogin);

        checkoutLogin.login.$wrap.modal();

        checkoutLogin.$wrap   = checkoutLogin.login.$wrap;
        checkoutLogin.$anchor = checkoutLogin.login.$anchor;
        checkoutLogin.login   = checkoutLogin.login;

        checkoutLogin.listen();
    };

    this.show = function() {
        checkoutLogin.login.loading();
        checkoutLogin.$wrap.modal();
        checkoutLogin.guest = false;
    };

    this.listen = function() {
        checkoutLogin.login.$guest.click( function() {
            checkoutLogin.guest = true;
            checkoutLogin.proceed();
        } );
    };

	this.proceed = function() {
		checkoutLogin.login.$wrap.modal('hide');
		
		if ( checkout.config.saveForLater ) {
			checkout.cart.saveForLater.syncWishList();
			checkout.cart.saveForLater.loadWishListSavedItems(false);
		}

    // if we're logging in after already loading the guest address form,
    // load it with data from the customer's account
    if( checkout.shipinfo ) checkout.shipinfo.setFormDataFromSession();
    if( checkout.billinfo ) checkout.billinfo.callInfoChangedListeners();

    checkout.nextStep();
	};

    this.loadAddresses = function() {
        var data = {
			currentShipID: checkout.session.get('shipID'),
			addresses: checkout.session.get('shippingAddresses'),
		};

        $('.select-address-modal .address-list').html(
            Jemplate.process('shippingAddressRows', data)
        );
		// update checkout.config.shippingAddresses are updated when logging in (see setAfterShipping)
		checkout.config.shippingAddresses = checkout.session.get('shippingAddresses');
        if (checkout.shipping) checkout.shipping.init();
    }
	
	this.setEstimatedShippingFields = function() {
		var shipping = checkout.session.get('shipping');
		if (shipping && shipping.country && shipping.zip) {
			checkout.cart.shipping.$country.val(shipping.country);
			checkout.cart.shipping.$zip.val(shipping.zip);
			checkout.cart.shipping.calc(true, true);
			checkout.cart.shipping.updateEstimatedShippingLink();
		}
	}

	this.init();
};
